const cleanZipcodes = value => {
  return value.map(a => a.value || a);
};

export default cleanZipcodes;
